export default __webpack_public_path__ + "static/media/knockbackimmunity.05007c60.png";